import React from "react"

import { VIEWBOX_CENTER_X, VIEWBOX_CENTER_Y } from "./constants"
import { StyledPath } from "./styles"

const Path = ({ pathRadius, dashRatio, colour }) => {
  const getPathDescription = () => {
    const radius = pathRadius
    const rotation = 0

    return `
		M ${VIEWBOX_CENTER_X},${VIEWBOX_CENTER_Y}
		m 0,-${radius}
		a ${radius},${radius} ${rotation} 1 1 0,${2 * radius}
		a ${radius},${radius} ${rotation} 1 1 0,-${2 * radius}
	`
  }
  const getDashStyle = () => {
    const diameter = Math.PI * 2 * pathRadius
    const gapLength = (1 - dashRatio) * diameter

    return {
      strokeDasharray: `${diameter}px ${diameter}px`,
      strokeDashoffset: `${gapLength}px`,
    }
  }
  return (
    <StyledPath
      colour={colour}
      style={getDashStyle()}
      d={getPathDescription()}
    />
  )
}

export default Path
